var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00001,
    cy: 8,
    r: 6,
    stroke: "#6E8792",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15999 6.4C8.51346 6.4 8.79999 6.16122 8.79999 5.86667L8.79999 5.33334C8.79999 5.03878 8.51346 4.8 8.15999 4.8H7.51999C7.16653 4.8 6.87999 5.03878 6.87999 5.33334L6.87999 5.86667C6.87999 6.16122 7.16653 6.4 7.51999 6.4L8.15999 6.4Z",
    fill: "#EAEDEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83936 6.93334H7.03999C6.68653 6.93334 6.39999 7.03878 6.39999 7.33333C6.39999 7.62788 6.68653 7.73333 7.03999 7.73333H7.51999V10.4H7.03999C6.68653 10.4 6.39999 10.5054 6.39999 10.8C6.39999 11.0945 6.68653 11.2 7.03999 11.2H8.95755C9.31102 11.2 9.59999 11.0945 9.59999 10.8C9.59999 10.5054 9.31101 10.4 8.95755 10.4H8.47999V7.46667C8.47999 7.17212 8.19282 6.93334 7.83936 6.93334Z",
    fill: "#EAEDEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f0aae8b9c25058378477cf6ba7a4962a.svg";
export { ForwardRef as ReactComponent };